<template>
  <div class="flex items-center" @click="clickItem(campusItemData)">
    <div class="logo-container flex justify-center items-center">
      <img
        class="logo"
        :src="campusItemData.company_logo || campusItemData.company_logo_hr || 'https://files.wondercv.com/icon/Artboard.png'"
        alt=""
      />
    </div>
    <div class="content-info">
      <div class="title">
        <span>{{ campusItemData.company_name }}</span>
      </div>
      <div class="tags">
        <span v-if="campusItemData.category">{{ campusItemData.category }}/</span>
        <span>{{ campusItemData.city_names | cityFilter }}</span>
      </div>
      <div class="time flex items-center">
        <i class="iconfont iconshijian"></i>
        <p class="infos-time">{{ recruitmentTime(campusItemData.comp_recruit_info) }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { recruitmentTime } from '@/assets/js/util';
export default {
  name: 'CampusItem',
  props: {
    campusItemData: {
      type: Object,
      required: true,
    },
  },
  filters: {
    cityFilter(val) {
      if (val && val.length) {
        let cityStr = '';
        val.forEach((item, index) => {
          if (index < 2) cityStr += `${item}、`;
        });
        return val.length > 2 ? cityStr.slice(0, -1) + '等' : cityStr.slice(0, -1);
      } else {
        return '全国';
      }
    },
  },
  methods: {
    recruitmentTime,
    clickItem(item) {
      this.$emit('clickItem', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.logo-container {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #eee;
  margin-right: 16px;
  .logo {
    width: 100%;
    object-fit: contain;
  }
}
.content-info {
  display: flex;
  flex-direction: column;
  .title {
    font-size: 16px;
    line-height: 16px;
    color: #404040;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .tags {
    font-size: 12px;
    line-height: 12px;
    color: #404040;
    margin-bottom: 10px;
  }
  .time {
    font-size: 12px;
    line-height: 12px;
    color: #909090;
    .iconfont {
      font-size: 12px;
      color: #ff6644;
      margin-right: 4px;
    }
  }
}
</style>
